import { logInfo } from 'setup/logger/logInfo';
import { activateWaitingServiceWorker } from './alignment';
import { getServiceWorkerContainer } from './serviceWorkerContainer';

/** How long to wait for the new worker to take over before reloading anyway. */
const ACTIVATION_WAIT_MS = 1_000;

/**
 * Activates a newer worker waiting to take over (as the update banner does)
 * and reloads the page, so page and worker run the same version. `trigger`
 * tells in the logs where the user asked for it.
 */
export async function updateServiceWorkerAndReload(trigger: string): Promise<void> {
  try {
    const registration = await getServiceWorkerContainer()?.getRegistration();
    const waitingWorker = registration?.waiting;
    if (waitingWorker) {
      logInfo('service-worker-update-applied', { trigger });
      await activateWaitingServiceWorker(waitingWorker, ACTIVATION_WAIT_MS);
    }
  } catch (error) {
    logInfo('service-worker-update-failed', { trigger, error });
  }
  window.location.reload();
}
